import { EnvConstants } from '../../../EnvConstants';
import FormFw from '../../../framework/form/FormFw';
import { BasePage } from "../../../framework/pages/BasePage";
import { LoadUtil } from '../../../framework/util/LoadUtil';
import { S3Util } from '../../../util/S3Util';
import { Image } from 'antd';
import { UserUtil } from '../../../util/UserUtil';
import { MessageUtil } from '../../../util/MessageUtil';
import { PAGE_MODE } from '../../../constants/constants';

export class FirmaClienteAdminPage extends BasePage {
  constructor(props) {
    super(props);
    this.state = {
      image: null,
      loadingImage: false
    };
  }

  createPageProperties = () => {
    return {
      title: 'FIRMA CLIENTE'
    };
  };

  async loadImageFromS3(filename, folder) {
    this.setState({ loadingImage: true });

    try {
      const resp = await S3Util.preview(filename, folder);
      this.setState({
        image: resp?.url || null,
        loadingImage: false
      });
    } catch (error) {
      console.error("Error cargando imagen S3:", error);
      this.setState({ loadingImage: false });
    }
  }

  renderPage(pageApi) {
    const getFormS3 = () => pageApi.getComponent("formS3");

    const formS3 = {
      autoLoad: true,
      title: "Adjuntar Firma",
      layout: 'vertical',
      load: {
        queryId: 900,
        params: { id_usuario: UserUtil.getUserId() },
        hideMessage: true,
        hideMessageError: true,
        fnOk: (resp) => {
          if (resp.dataObject) {
            this.loadImageFromS3(resp.dataObject?.nombreArchivo, resp.dataObject?.carpeta);
          }
        }
      },
      fields: [
        {
          type: "dragger",
          name: "archivo",
          label: "",
          accept: ".png",
          multiple: 1,
          folder: "bvdigital-repository-ma-per-pr/solicitud-servicio/cadena-custodia/firma-usuario",
          onChange: (value, values) => {

            let lst = getFormS3()
              .getFieldApi("archivo")
              .getFileList();

            if (lst && lst.length > 0) {
              lst.forEach((file) => {
                S3Util.getUrlS3(
                  file.fileId,
                  "bvdigital-repository-ma-per-pr/solicitud-servicio/cadena-custodia/firma-usuario"
                ).then(async (urlComplete) => {
                  await this.loadImageFromS3(file.fileId, "bvdigital-repository-ma-per-pr/solicitud-servicio/cadena-custodia/firma-usuario")
                  LoadUtil.loadByQueryId({
                    url: EnvConstants.GET_FW_FORM_URL_SAVE_BASE(),
                    queryId: 899,
                    reqParams: {
                      params: {
                        filename: file.fileId,
                        folder: "bvdigital-repository-ma-per-pr/solicitud-servicio/cadena-custodia/firma-usuario",
                        id_usuario: UserUtil.getUserId(),
                      },
                    },
                    fnOk: (resp) => {
                      if (resp.message) {
                        MessageUtil("success", resp.message, "");
                      } else if (resp.error) {
                        MessageUtil("warning", resp.error, "");
                      }
                    },
                  });
                });
              });
            }

            getFormS3().reset();
          },
          column: 12,
        },
      ],
      onComponentLoad: (formApi, pageApi) => {
        if (pageApi.getPageMode() !== PAGE_MODE.NEW) formApi.load();
      },
    };

    return (
      <div
        style={{
          display: 'flex',
          gap: '15px',
          flexWrap: 'wrap'
        }}
      >
        <div
          style={{
            flex: '1 1 500px',
            minWidth: '300px'
          }}
        >
          <FormFw
            name="formS3"
            getParentApi={pageApi.getApi}
            config={formS3}
          />
        </div>

        <div
          style={{
            flex: '1 1 250px',
            minWidth: '300px',
            display: 'flex',
            justifyContent: 'center'
          }}
        >
          <Image
            src={this.state.image}
            style={{
              width: '100%',
              borderRadius: '12px'
            }}
            placeholder={this.state.loadingImage}
          />
        </div>
      </div>

    );
  }
}
